:host{display:block;width:1024px}
/*# sourceMappingURL=line-svg.component-5747QANL.css.map */
